"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.listenImage = listenImage;

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _ImageBase = _interopRequireDefault(require("./ImageBase.js"));

var _ImageState = _interopRequireDefault(require("./ImageState.js"));

var _has = require("./has.js");

var _extent = require("./extent.js");

var _events = require("./events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Image
 */


/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(ImageWrapper, string): void} LoadFunction
 * @api
 */
var ImageWrapper =
/** @class */
function (_super) {
  __extends(ImageWrapper, _super);
  /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|undefined} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {LoadFunction} imageLoadFunction Image load function.
   */


  function ImageWrapper(extent, resolution, pixelRatio, src, crossOrigin, imageLoadFunction) {
    var _this = _super.call(this, extent, resolution, pixelRatio, _ImageState["default"].IDLE) || this;
    /**
     * @private
     * @type {string}
     */


    _this.src_ = src;
    /**
     * @private
     * @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement}
     */

    _this.image_ = new Image();

    if (crossOrigin !== null) {
      _this.image_.crossOrigin = crossOrigin;
    }
    /**
     * @private
     * @type {?function():void}
     */


    _this.unlisten_ = null;
    /**
     * @protected
     * @type {import("./ImageState.js").default}
     */

    _this.state = _ImageState["default"].IDLE;
    /**
     * @private
     * @type {LoadFunction}
     */

    _this.imageLoadFunction_ = imageLoadFunction;
    return _this;
  }
  /**
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */


  ImageWrapper.prototype.getImage = function () {
    return this.image_;
  };
  /**
   * Tracks loading or read errors.
   *
   * @private
   */


  ImageWrapper.prototype.handleImageError_ = function () {
    this.state = _ImageState["default"].ERROR;
    this.unlistenImage_();
    this.changed();
  };
  /**
   * Tracks successful image load.
   *
   * @private
   */


  ImageWrapper.prototype.handleImageLoad_ = function () {
    if (this.resolution === undefined) {
      this.resolution = (0, _extent.getHeight)(this.extent) / this.image_.height;
    }

    this.state = _ImageState["default"].LOADED;
    this.unlistenImage_();
    this.changed();
  };
  /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @api
   */


  ImageWrapper.prototype.load = function () {
    if (this.state == _ImageState["default"].IDLE || this.state == _ImageState["default"].ERROR) {
      this.state = _ImageState["default"].LOADING;
      this.changed();
      this.imageLoadFunction_(this, this.src_);
      this.unlisten_ = listenImage(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
    }
  };
  /**
   * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
   */


  ImageWrapper.prototype.setImage = function (image) {
    this.image_ = image;
    this.resolution = (0, _extent.getHeight)(this.extent) / this.image_.height;
  };
  /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */


  ImageWrapper.prototype.unlistenImage_ = function () {
    if (this.unlisten_) {
      this.unlisten_();
      this.unlisten_ = null;
    }
  };

  return ImageWrapper;
}(_ImageBase["default"]);
/**
 * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image element.
 * @param {function():any} loadHandler Load callback function.
 * @param {function():any} errorHandler Error callback function.
 * @return {function():void} Callback to stop listening.
 */


function listenImage(image, loadHandler, errorHandler) {
  var img =
  /** @type {HTMLImageElement} */
  image;
  var listening = true;
  var decoding = false;
  var loaded = false;
  var listenerKeys = [(0, _events.listenOnce)(img, _EventType["default"].LOAD, function () {
    loaded = true;

    if (!decoding) {
      loadHandler();
    }
  })];

  if (img.src && _has.IMAGE_DECODE) {
    decoding = true;
    img.decode().then(function () {
      if (listening) {
        loadHandler();
      }
    })["catch"](function (error) {
      if (listening) {
        if (loaded) {
          loadHandler();
        } else {
          errorHandler();
        }
      }
    });
  } else {
    listenerKeys.push((0, _events.listenOnce)(img, _EventType["default"].ERROR, errorHandler));
  }

  return function unlisten() {
    listening = false;
    listenerKeys.forEach(_events.unlistenByKey);
  };
}

var _default = ImageWrapper;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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